import * as ACCESS_RESOURCE from '../accessControl/accessResource';

export const AGENCY_TAGGED_DATA_FIELD = 'last_attributed_touch_data.~agency_id';

export const LOCATION_FIELD = 'user_data.geo_country_code';

export const AD_NETWORKS_FIELD = 'last_attributed_touch_data.$3p';

export const PROTECTED_LUCENE_FIELDS_TO_PERMISSION_KEYS = {
  [AGENCY_TAGGED_DATA_FIELD]: ACCESS_RESOURCE.AGENCY_TAGGED_DATA,
  [LOCATION_FIELD]: ACCESS_RESOURCE.LOCATION,
  [AD_NETWORKS_FIELD]: ACCESS_RESOURCE.AD_NETWORKS,
};

export const PERMISSION_KEYS_TO_PROTECTED_LUCENE_FIELDS = {
  [ACCESS_RESOURCE.AGENCY_TAGGED_DATA]: AGENCY_TAGGED_DATA_FIELD,
  [ACCESS_RESOURCE.LOCATION]: LOCATION_FIELD,
  [ACCESS_RESOURCE.AD_NETWORKS]: AD_NETWORKS_FIELD,
};

export const PROTECTED_LUCENE_FIELDS = [
  ACCESS_RESOURCE.AGENCY_TAGGED_DATA,
  ACCESS_RESOURCE.LOCATION,
  ACCESS_RESOURCE.AD_NETWORKS,
];
